import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// create individual webpack chunk for each view, so we are loading each of them only when needed
function loadView(view: string) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      component: loadView("PageNotFound"),
    },
    {
      path: "/",
      name: "landing-page",
      component: loadView("LandingPage"),
      meta: {
        requiresAuth: false,
       },
    },
    {
      path: "/event/overview",
      name: "overview",
      component: loadView("Overview"),
      meta: {
        requiresAuth: true,
       },
    },
    {
      path: "/stats",
      name: "stats",
      component: loadView("Stats"),
      meta: {
        requiresAuth: true,
       },
    },
    {
      path: "/profile",
      name: "profile",
      component: loadView("Profile"),
      meta: {
        requiresAuth: true,
       },
    },
    {
      path: "/event/:eventId",
      name: "event",
      component: loadView("EventView"),
      meta: {
        requiresAuth: true,
       },
    },
    {
      path: "/public-list/:eventId",
      name: "public-list",
      component: loadView("CreatePublicListView"),
      meta: {
        requiresAuth: false,
       },
    },
    {
      path: "/create-public-list/",
      name: "create-public-list",
      component: loadView("CreatePublicListView"),
      meta: {
        requiresAuth: false,
       },
    },
    {
      path: "/contribute/overview",
      name: "contribute-overview",
      component: loadView("ContributeOverview"),
      meta: {
        requiresAuth: true,
        requiresEmailVerification: true,
       },
    },
    {
      path: "/contribute/:eventId",
      name: "contribute",
      component: loadView("ContributeView"),
      meta: {
        requiresAuth: false,
        requiresEmailVerification: true,
       },
    },
    {
      path: "/email-verification-required",
      name: "email-verification-required",
      component: loadView("EmailVerificationRequired"),
      meta: {
        requiresAuth: true,
       },
    },
    {
      path: "/sign-in-to-continue",
      name: "sign-in-to-continue",
      component: loadView("SignInToContinuePage"),
      meta: {
        requiresAuth: false,
       },
    },
    {
      path: "/signed-out",
      name: "signed-out",
      component: loadView("SignedOutPage"),
      meta: {
        requiresAuth: true,
       },
    },
  ],
});
